<div class="flex align-items-center justify-content-between flex-wrap">
  <h2 class="my-1" id="payment-methods-heading">Payment Methods</h2>
  <button 
    pButton 
    type="button" 
    label="Add new payment method"
    icon="mi-round mi-add-circle-outline"
    class="p-button-text p-button-sm my-4"
    aria-label="Add New Payment Method"
    (click)="showNewPaymentMethodModal()"
  ></button>
</div>
<p-divider role="separator" aria-orientation="horizontal"></p-divider>

<div class="mt-4" role="region" aria-labelledby="payment-methods-heading">
  <ng-container *ngIf="paymentMethodControl.value?.length; else noPaymentMethods">
    <app-payment-method-radio
      [control]="paymentMethodControl"
      name="paymentMethod"
    ></app-payment-method-radio>
  </ng-container>
  <ng-template #noPaymentMethods>
    <p>No payment methods saved.</p>
  </ng-template>
</div>

<app-payment-method-form
  [(visible)]="displayNewPaymentMethodModal"
  (submitForm)="onPaymentMethodCreated($event)"
></app-payment-method-form>
